export default __webpack_public_path__ + "static/popup-d-1e85ef72fa4e4ae6a0579da9b63119c2.jpg";